var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallOfYarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 284,
    viewBox: "0 0 289 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 142.072,
    r: 71,
    fill: "#F391C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244 54.0719C210.5 99.5719 248.229 102.072 244 147.541C240.373 186.539 186.665 184.667 173.528 181.077",
    stroke: "#F8A4CF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163 75.5719C163 108.572 144.5 174.072 94 191.572",
    stroke: "#FBA0CF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0001 159.171C95.2975 132.401 148.607 90.0862 199.806 105.421",
    stroke: "#FBA0CF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.428 107.366C191.758 139.462 166.184 199.153 113 204.436",
    stroke: "#FBA0CF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.546 202.919C140.415 189.462 86.4646 153.318 91.08 100.072",
    stroke: "#FBA0CF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.5 190.572C147 152.072 127.385 128.818 132 75.5719",
    stroke: "#FBA0CF",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.888 103.073C177.863 132.454 138.93 184.427 86 177.015",
    stroke: "#FDA9D4",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180 87.0719C164.975 116.453 129.93 166.427 77 159.015",
    stroke: "#FDA9D4",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113.549C112.173 106.206 175.702 122.16 204 167.5",
    stroke: "#FFB0D9",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2541 101.185C135.5 81.5719 183 95 210 139.5",
    stroke: "#FFB0D9",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6554 128.072C109.654 128.424 173.533 140.105 190.493 190.789",
    stroke: "#FFB0D9",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallOfYarn);
export default __webpack_public_path__ + "static/media/ball-of-yarn.46db5fc435701aa6f1b4309c0a6510c3.svg";
export { ForwardRef as ReactComponent };